const TAG_GETTERS = {
  getTagList: (state) => state.tags,
};

export default TAG_GETTERS;
